import { render } from "./SelectionSetControlRenderer.vue?vue&type=template&id=07879b56&scoped=true&ts=true"
import script from "./SelectionSetControlRenderer.vue?vue&type=script&lang=ts"
export * from "./SelectionSetControlRenderer.vue?vue&type=script&lang=ts"

import "./SelectionSetControlRenderer.vue?vue&type=style&index=0&id=07879b56&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07879b56"]])

export default __exports__